/* first-order code: tap to copy */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    var code = btn.dataset.copyCode;
    var label = btn.querySelector('[data-copy-label]');
    var done = function () {
      btn.classList.add('is-copied');
      if (label) label.textContent = 'Copied!';
      setTimeout(function () { btn.classList.remove('is-copied'); if (label) label.textContent = code; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else done();
  });
})();

